import React from 'react'

export const LoadingState = ({ text }) => (
    <div className="rt-loading">
        <i className="fas fa-circle-notch fa-spin" aria-hidden="true" />
        <span>{text}</span>
    </div>
)
